<template>
  <div class="first-label">
    <div class="first-label-wrapper clearfix" v-if="title">
      <p class="first-label-title" :title="title">
        {{title}}
      </p>
      <slot name="headSlot"></slot>
    </div>
    <div class="first-label-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'
.first-label
  margin-bottom: 12px;
  .first-label-wrapper
    border-bottom 1px solid #e4e4e4
    margin-bottom: 10px;
    padding-bottom: 12px;
    .first-label-title
      font2()
      font-size: 11px;
      // padding-bottom 8px
      float left
      line-height 32px
      & >>> > .some-search-items
        display inline-block
    .first-label-content
      margin-left 3px
      & >>> .some-search
        border-bottom: none;
        margin-bottom: 0px;
  & >>> .some-search-label
    background: #f2f2f2;
    padding-left: 9px;
    padding-right: 9px;
    flex-basis: 96px;
    margin-right: 16px;
    border-radius 1px
    ddd()

</style>



// WEBPACK FOOTER //
// src/components/base/letterSearch/FirstLabel.vue